/**
 * MasteryScreen (Fase 10 · §46) — trilha de REGIONAL MASTERY de uma região. Mostra nível,
 * XP e a progressão de recompensas conquistadas JOGANDO. Não é Battle Pass, não tem timer,
 * não vende nada (§47). Segue o padrão modal (overlay/panel/void-panel).
 */
import { i18n } from "../i18n/i18n";

export interface MasteryRewardRow {
  level: number;
  label: string;
  earned: boolean;
  isNext: boolean;
}
export interface MasteryView {
  regionName: string;
  level: number;
  max: number;
  xpInto: number;
  xpNext: number; // 0 = maxed
  rewards: MasteryRewardRow[];
}

export class MasteryScreen {
  private readonly root: HTMLDivElement;
  private readonly body: HTMLDivElement;
  private readonly closeBtn: HTMLButtonElement;
  private provider: (() => MasteryView) | null = null;

  constructor(uiRoot: HTMLElement, private readonly onClose: () => void) {
    this.root = document.createElement("div");
    this.root.className = "overlay";
    this.root.hidden = true;
    this.root.innerHTML = `
      <div class="panel mastery-panel void-panel">
        <h2></h2>
        <div class="mastery-body"></div>
        <button class="btn primary" data-a="close"></button>
      </div>`;
    uiRoot.appendChild(this.root);
    this.body = this.root.querySelector(".mastery-body")!;
    this.closeBtn = this.root.querySelector('[data-a="close"]')!;
    this.closeBtn.onclick = () => this.onClose();
    i18n.onChange(() => {
      if (!this.root.hidden) this.render();
    });
  }

  open(provider: () => MasteryView): void {
    this.provider = provider;
    this.render();
    this.root.hidden = false;
  }
  close(): void {
    this.root.hidden = true;
  }

  private render(): void {
    if (!this.provider) return;
    const v = this.provider();
    (this.root.querySelector("h2") as HTMLElement).textContent = i18n.t("mastery.title");
    this.closeBtn.textContent = i18n.t("world.close");

    const pct = v.xpNext > 0 ? Math.round((v.xpInto / v.xpNext) * 100) : 100;
    const xpText = v.xpNext > 0 ? `${Math.floor(v.xpInto)} / ${v.xpNext} XP` : i18n.t("mastery.maxed");

    let html = `
      <div class="mastery-head">
        <span class="mastery-region">${v.regionName}</span>
        <span class="mastery-lv">${v.level}<span style="font-size:0.5em;color:var(--text-dim)">/${v.max}</span></span>
      </div>
      <div class="mastery-xpbar"><div class="mastery-xpfill" style="width:${pct}%"></div></div>
      <div style="text-align:right;font-size:var(--fs-caption);color:var(--text-dim);margin:-6px 0 12px">${xpText}</div>
      <div class="mastery-track">`;
    for (const r of v.rewards) {
      const cls = "mrow" + (r.earned ? " earned" : "") + (r.isNext ? " next" : "");
      const tick = r.earned ? "✦" : "";
      html += `<div class="${cls}"><span class="mrow-lv">${i18n.t("mastery.lv", { n: r.level })}</span><span class="mrow-rw">${r.label}</span><span class="mrow-tick">${tick}</span></div>`;
    }
    html += `</div>`;
    this.body.innerHTML = html;
  }
}
